import { getAppVersion } from './params';
/**
 * 不符合要求的火星App端版本号
 */
export var invalidVersionList = [
    '4.9.0.3',
    '4.9.0.4',
    '4.10.0',
    '4.11.0.1',
    '4.11.0.2',
    '4.12.0',
    '4.14.0',
    '4.9.0.3.debug',
    '4.9.0.4.debug',
    '4.10.0.debug',
    '4.11.0.1.debug',
    '4.11.0.2.debug',
    '4.12.0.debug',
    '4.14.0.debug',
];
/**
 * 当前宿主的userAgent
 */
export var ua = navigator.userAgent.toLowerCase();
/**
 * 获取当前浏览器是否具有火星浏览器的标签
 */
export var mars = getAppVersion('easylive') || '';
/**
 * 获取当前浏览器是否具有唱吧浏览器的标签
 */
export var cb = getAppVersion('changba') || '';
/**
 * 是否不是有效的唱吧标记
 */
export var isInvalidChangba = /changba/.test(navigator.userAgent.toLowerCase()) && invalidVersionList.includes(cb);
/**
 * 当前是否运行在安卓浏览器中
 */
export var isAndroid = ua.indexOf('android') > 0;
/**
 * 当前是否运行在iOS浏览器中
 */
export var isIOS = /iphone|ipad|ipod/.test(ua);
/**
 * 当前是否运行在QQ或者微信的内置浏览器中
 */
export var isQQorWeChat = /micromessenger|qq\//.test(ua);
/**
 * 当前是否运行在微博的内置浏览器中
 */
export var isWeibo = /\s+weibo\s+/.test(ua);
/**
 * 当前是否运行在微信小程序中
 */
export var isWXMP = /miniprogram/.test(ua) || window.__wxjs_environment === 'miniprogram';
/**
 * 当前是否运行在唱吧以外的环境
 */
export var isOutChangba = ua.indexOf('changba') < 0 || isQQorWeChat || isWeibo || /cblive/.test(ua) || isWXMP;
/**
 * 当前项目是否运行在火星app内，这个变量只能判断是运行在火星app内，无法判断这个项目是否是火星项目
 */
export var isMars = /easylive/.test(navigator.userAgent.toLowerCase()) || isInvalidChangba;
/**
 * 当前项目是否运行在唱吧app内
 */
export var isChangba = /changba/.test(navigator.userAgent.toLowerCase()) && !isInvalidChangba;
/**
 * 这个变量无法判断当前活动是否运行在火星内，但是能够判断当前活动是否是一个火星活动
 */
export var isMarsProject = window.location.host === 'mars.changba.com' || typeof MARS !== 'undefined';
